/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGithubOrganization extends models.ServiceAccountNativeDetailsForGithubBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGithubOrganization");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGithubOrganization.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGithubOrganization>): ServiceAccountNativeDetailsForGithubOrganization {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGithubOrganization(), model);
        ServiceAccountNativeDetailsForGithubOrganization.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGithubOrganization>): ServiceAccountNativeDetailsForGithubOrganization {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGithubOrganization.newInstance(<ServiceAccountNativeDetailsForGithubOrganization> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGithubOrganization) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGithubOrganization.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGithubOrganization): boolean {
        if (models.ServiceAccountNativeDetailsForGithubBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGithubOrganization.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Organization Id. This is a required field
     */
    organization_id: string;

}
